/* eslint-disable no-unused-vars */
import { DatePicker, Form } from 'antd';

const { RangePicker } = DatePicker;

function DateRangePicker({ FormInputName, FormInputLabel, FormInputRules }) {
    return (
        <>
            <Form.Item name="date_on_sale_from" label="Start - End Date">
                <RangePicker />
            </Form.Item>
        </>
    );
}

export default DateRangePicker;
